/**
 * A aprovação de desconto viaja nos cabeçalhos da requisição que grava a venda, e não num campo de
 * cada documento: são oito telas com payloads próprios, e um campo esquecido numa delas seria a
 * venda chegando ao servidor sem a aprovação que o vendedor acabou de conseguir.
 *
 * A tela define o contexto logo antes de gravar e limpa depois. O interceptor do axios
 * (jwtService) só põe os cabeçalhos nas rotas que gravam venda, e o contexto vence sozinho em dois
 * minutos — um contexto esquecido nunca acompanha uma venda de outra pessoa.
 */
const ROTAS_DE_VENDA = /^\/?(auxiliar|auxiliar-servico|nfce|nfe|nfse|orcamento|ordem-servico)(\/[^/]+)?\/?(\?.*)?$/;
const VALIDADE_MS = 2 * 60 * 1000;

let contexto = null;

export const definirContextoDesconto = (chave, aprovacaoId) => {
  contexto = chave ? { chave, aprovacaoId: aprovacaoId || null, em: Date.now() } : null;
};

export const limparContextoDesconto = () => {
  contexto = null;
};

/** Os cabeçalhos da aprovação para esta requisição, ou nada. */
export const cabecalhosDesconto = (config) => {
  if (!contexto || !config) return null;
  if (Date.now() - contexto.em > VALIDADE_MS) {
    contexto = null;
    return null;
  }
  const metodo = String(config.method || "").toLowerCase();
  if (metodo !== "post" && metodo !== "put") return null;
  const url = String(config.url || "").replace(/^https?:\/\/[^/]+/, "");
  if (!ROTAS_DE_VENDA.test(url)) return null;
  const h = { "X-Desconto-Chave": contexto.chave };
  if (contexto.aprovacaoId) h["X-Desconto-Aprovacao"] = String(contexto.aprovacaoId);
  return h;
};

/** Grava a venda com o contexto definido e limpa ao terminar, dê certo ou não. */
export const comContextoDesconto = async (chave, aprovacaoId, gravar) => {
  definirContextoDesconto(chave, aprovacaoId);
  try {
    return await gravar();
  } finally {
    limparContextoDesconto();
  }
};
